import { ROUTES } from '@/routes';
import { useNavigate } from 'react-router-dom';

interface ReviewInquiryStatusCardProps {
  label: string;
  count: number;
  filter: 'reviews' | 'inquiries';
  icon?: React.ReactNode;
  onClickBefore?: () => void; // 추가
}

const ReviewInquiryStatusCard = ({
  label,
  count,
  filter,
  icon,
  onClickBefore,
}: ReviewInquiryStatusCardProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // 로그 이벤트 먼저 실행
    onClickBefore?.();

    // 기존 네비게이션 로직
    navigate(`${ROUTES.orders}/${filter}?ctab=whole`);
  };

  return (
    <div onClick={handleClick} className=" flex h-full w-full flex-1 cursor-pointer">
      <div className="flex  w-full items-center justify-between">
        <div className="flex items-center gap-[12px]">
          {icon && <div className="">{icon}</div>}
          <p className="text-[15px] font-medium leading-[22px] text-gr-700">{label}</p>
        </div>

        <div className="flex items-center gap-[2px] text-gr-900 Body1S16">
          <span>{count.toLocaleString()}</span>
          <span className="text-gr-800">건</span>
        </div>
      </div>
    </div>
  );
};

export default ReviewInquiryStatusCard;
